import React from "react";

import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";

import styles from "./Success.module.scss";
type Props = {
  onClose: () => void;
};

const Success = (props: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.headerText}>
          おつかれさま！教えてくれてありがとう！
        </h1>

        <button className={styles.closeButton}>
          <CloseIcon onClick={props.onClose} />
        </button>
      </div>
      <div className={styles.content}>
        <p>
          今からヒントを考えるよ。ヒントは明日にはできあがるから、明日になったら見たいLessonの指導書をクリックしてね！
          <br />
          ぼくのヒントで先生が授業をしやすくなったらうれしいな。
        </p>
      </div>
    </div>
  );
};

export default Success;
